<div class="sidebar-menu">
    <div class="overlay">
        <span class="close_btn"></span>
    </div> 
    <div class="menu-content">
        <app-search></app-search>
        <ul class="main-nav" id="hammenu">
            <li class="has-children" *ngFor="let prod of hamburgerMenu; index as i">
                <a href="#">{{prod.title}}</a>
                <ul class="children-wrapper">
                    <li><strong>{{prod.category}}</strong></li>
                    <ng-container *ngFor="let submenu of prod.menu">
                        <li>
                            <!-- <a href="{{submenu.link}}" (click)="registerGASubMenu(submenu.name)">{{submenu.name}}</a> -->
                            <ng-container *ngIf="submenu.link.indexOf('/')==0">
                                <a href="https://www.bajajcapital.com{{submenu.link}}" target="_blank"
                                    (click)="registerGASubMenu(submenu.name)">{{submenu.name}}</a>
                            </ng-container>
                            <ng-container *ngIf="submenu.link.indexOf('/')!=0">
                                <a href="{{submenu.link}}" target="{{submenu.target}}"
                                    (click)="registerGASubMenu(submenu.name)">{{submenu.name}}</a>
                            </ng-container>
                        </li>
                    </ng-container>
                </ul>

            </li>
        </ul>
        <ul class="nav-links">
            <li><a href="https://www.bajajcapital.com/about-us" (click)="registerGASubMenu('About Us')">About Us</a></li>
            <li><a href="https://www.bajajcapital.com/blog" (click)="registerGASubMenu('Blog')">Blog</a></li>
            <li><a href="https://www.bajajcapital.com/help-centre" (click)="registerGASubMenu('Contact Us')">Contact Us</a></li>
            <li><a href="https://www.bajajcapital.com/careers" (click)="registerGASubMenu('Careers')">Careers</a></li>
            <li><a href="https://www.bajajcapital.com/term-conditions?doc=tnc"
                    (click)="registerGASubMenu('Terms and Conditions')">Terms and Conditions</a></li>

            <!-- <li><a [routerLink]="[branch_locatorarr]" (click)="registerGASubMenu('Branch Locator')" ><img src="assets/images/placeholder.svg" alt="" width="12">Branch Locator</a></li> -->
            <li><a href="https://www.bajajcapital.com/help-centre#branch" (click)="registerGASubMenu('Branch Locator')">
                    <!-- <img src="assets/images/placeholder.svg" alt="" width="12"> -->
                    <span class="material-icons-outlined">
                        location_on
                    </span>
                    Branch Locator</a></li>
            <li><a href="https://www.bajajcapital.com/help-centre#query" (click)="registerGASubMenu('Request Callback')">
                    <!-- <img src="assets/images/phone.svg" alt="" width="12"> -->
                    <span class="material-icons-outlined">
                        phone
                    </span>
                    Request Callback</a></li>
            <!-- <li><a href="{{req_callback}}" (click)="registerGASubMenu('Request Callback')" ><img src="assets/images/phone.svg" alt="" width="12">Request Callback</a></li> -->
            <!-- <li><a href="tel:{{tollfree_no}}" (click)="registerGASubMenu('tollfree_no')" ><img src="assets/images/phone.svg" alt="" width="12">{{tollfree_no}}</a></li> -->
            <li><a href="tel:{{tollfree_number}}" (click)="registerGASubMenu('1800313123123')">
                    <!-- <img src="assets/images/phone.svg" alt="" width="12"> -->
                    <span class="material-icons-outlined">
                        phone
                    </span>
                    {{tollfree_number}}</a></li>
            <span *ngIf="display_tollfree_2">
                <li><a href="tel:{{tollfree_num_2}}" (click)="registerGASubMenu('1800313123123')">
                        <!-- <img src="assets/images/phone.svg" alt="" width="12"> -->

                        <span class="material-icons-outlined">
                            phone
                        </span>{{tollfree_num_2}}</a></li>
            </span>
        </ul>
    </div>
</div>